export const VALIDATOR_CREATED_EVENT = 'formValidator:created';

export const EVENT_NAMES = {
    blur: 'blur',
    change: 'change',
    submit: 'submit'
};
